import { render, staticRenderFns } from "./VolunteersHoursDisplay.vue?vue&type=template&id=881de52a&"
import script from "./VolunteersHoursDisplay.vue?vue&type=script&lang=js&"
export * from "./VolunteersHoursDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports